import { render, staticRenderFns } from "./FillForm1StyleOfProceedingsInfo.vue?vue&type=template&id=2bacde18&scoped=true"
import script from "./FillForm1StyleOfProceedingsInfo.vue?vue&type=script&lang=ts"
export * from "./FillForm1StyleOfProceedingsInfo.vue?vue&type=script&lang=ts"
import style0 from "./FillForm1StyleOfProceedingsInfo.vue?vue&type=style&index=0&id=2bacde18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bacde18",
  null
  
)

export default component.exports